/**
 * Page transition singleton.
 *
 * Components that need to trigger a transition import `transitionTo`.
 * PageTransitionOverlay registers itself via `registerTransitionHandler`.
 */

let _handler = null

export function registerTransitionHandler(fn) {
  _handler = fn
}

/**
 * Trigger a page transition then navigate to `path`.
 *
 * @param {string} path         - React Router path to navigate to
 * @param {Object} [opts]
 * @param {'iris'|'glitch'|'polaroid'} [opts.type]  override VARIANT
 * @param {DOMRect}  [opts.rect]    origin rect for 'polaroid' type
 * @param {number}   [opts.rotate]  polaroid rotation (degrees)
 * @param {string}   [opts.src]     polaroid image src
 */
export function transitionTo(path, opts = {}) {
  if (_handler) {
    _handler(path, opts)
  }
}
